import { defineNuxtPlugin } from '#imports';

/**
 * 反向转换HTML实体字符。
 *
 * 该函数主要用于将HTML代码中的一些特殊字符实体转换回其原始字符。
 * 这对于处理从某些系统获取的HTML代码特别有用，这些系统可能将特殊字符转换为实体，
 * 但在我们的环境中，我们需要这些字符以原始形式存在。
 *
 * @param str 待处理的字符串，预计包含HTML实体字符。
 * @returns 返回处理后的字符串，其中HTML实体字符被转换回对应的原始字符。
 */
export const decodeRichText = (str: string) => {
  return str
    ? str.replace(/&((g|l|quo)t|amp|#39|nbsp);/g, m => {
        return (
          {
            // '&lt;': '<',
            // '&amp;': '&',
            // '&quot;': '"',
            // '&gt;': '>',
            // '&#39;': "'",
            '&nbsp;': ' ',
          }[m] || ''
        );
      })
    : '';
};

export default defineNuxtPlugin(nuxtApp => {
  Object.defineProperty(nuxtApp.vueApp.config.globalProperties, '$decodeRichText', {
    value: function (html: string) {
      return decodeRichText(html);
    },
  });
});
